export type Ratio = '16:9' | '9:16' | '1:1';

export const MEDIA_RATIO: { [ratio in Ratio]: [number, number] } = {
    '1:1': [1, 1],
    '16:9': [16, 9],
    '9:16': [9, 16],
};
